import { FollowUpActionResponseDtoStatus } from "@/generated/model";
import type { FollowUpActionWithSync } from "@/hooks/use-offline-follow-up-actions";

/** Whether a follow-up action still needs something from the current user. */
export function isActionableFollowUpAction(
  action: FollowUpActionWithSync,
  canSignOff: boolean,
): boolean {
  switch (action.status) {
    case FollowUpActionResponseDtoStatus.WAITING_APPROVAL:
      return canSignOff;
    case FollowUpActionResponseDtoStatus.OPEN:
    case FollowUpActionResponseDtoStatus.OVERDUE:
      return !action.localSyncStatus?.isLocallyCompleted;
    default:
      return false;
  }
}

export function countActionableFollowUpActions(
  actions: FollowUpActionWithSync[],
  canSignOff: boolean,
): number {
  return actions.filter((action) =>
    isActionableFollowUpAction(action, canSignOff),
  ).length;
}
